import subscriberCookie from '../modules/subscriberCookie';
import $ from 'jquery';

export default {
  initialized: false,
  modal: null,
  modalClose: null,
  form: null,
  hiddenFlag: 'subscribe-modal--hidden',

  _bindEvents() {

    this.modalClose.addEventListener( 'click', e => {
      this.hide();
    });

    document.addEventListener('keydown', (e) => {
      if ( e.key == 'Escape' ) this.hide();
    });
  },

  init() {
    this.modal = document.querySelector('#subscribe-modal');
    if ( !this.modal ) return;

    this.modalClose = document.querySelector('#subscribe-modal-close');
    this.form = this.modal.querySelector('form');

    this._bindEvents();
  },

  show() {
    if ( !this.initialized ) this.init();
    this.modal.classList.remove(this.hiddenFlag);
  },

  hide() {
    if ( !this.initialized ) this.init();
    this.modal.classList.add(this.hiddenFlag);
    if ( !subscriberCookie.exists('drElseySubscriberV1') ) {
      subscriberCookie.setNoInterest('drElseySubscriberV1');
    }
  },
}

